import './index.css';
import React from 'react';
import Sidebar from './Components/Sidebar'

const App = () => {
  return (
    <React.Fragment>
      <Sidebar />
    </React.Fragment>
  )
}

export default App;
